<template>
  <section class="content">
    <admin-header
      :title="'Job Types'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminJobType',
    data () {
      return {
        newEntityScreen: 'Admin - Job Types',
        searchEntityScreen: 'Admin - Job Type search',
        filterEventName: 'admin-job-type-filter',
        filterName: 'JobTypeFilter',
        entityName: 'job-type'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/JobType/AdminJobType.vue